import { format } from 'rut.js';
import { columns } from '../../../../dtos/columns';
import Conversiones from '../../../../utils/conversiones';
import { RecaudacionDiariaReportDto } from '../models/recaudacionDiara';

export const useColumns = () => {
    const COLUMNS: columns<RecaudacionDiariaReportDto>[] = [
        {
            name: 'N° Operación',
            selector: (row) => row.numeroOperacion,
            sortable: true,
            sortField: 'numeroOperacion',
            wrap: true,
            export: true,
        },
        {
            name: 'N° Dividendo',
            selector: (row) => row.numeroDividendo,
            sortable: true,
            sortField: 'numeroDividendo',
            wrap: true,
            export: true,
        },
        {
            name: 'Procedencia de Fondos',
            selector: (row) => format(row.recaudadorRut ?? ""),
            sortable: true,
            sortField: 'recaudadorRut',
            wrap: true,
            export: true,
        },
        {
            name: 'Sucursal Pago',
            selector: (row) => row.sucursalPago,
            sortable: true,
            sortField: 'sucursalPago',
            wrap: true,
            export: true,
        },
        {
            name: 'Fecha Vencimiento',
            selector: (row) => Conversiones.fechaCortaFormat(row.fechaVencimiento?.toString() ?? "N/A"),
            sortable: true,
            sortField: 'fechaVencimiento',
            wrap: true,
            export: true,
        },
        {
            name: 'Total Recaudado',
            selector: (row) => row.totalRecaudado,
            sortable: true,
            sortField: 'totalRecaudado',
            wrap: true,
            export: true,
        },
        {
            name: 'Fecha Contabilización',
            selector: (row) => Conversiones.fechaCortaFormat(row.fechaContabilizacion?.toString() ?? "N/A"),
            sortable: true,
            sortField: 'fechaContabilizacion',
            wrap: true,
            export: true,
        },
        {
            name: 'Usuario',
            selector: (row) => row.nombreUsuario,
            sortable: true,
            sortField: 'nombreUsuario',
            wrap: true,
            export: true,
        },
    ];

    return COLUMNS;
};